export { default } from './ImageZoomAdmin';
